import { IOwnershipTypeModel } from "@/models/IOwnershipTypeModel";
import VetQuestApi from "./VetQuestApi";
import { ISearchBarOptionModel, ResponseModel } from "@/models";

export abstract class OptionService {
  static GetSearchbarOption = async (): Promise<
    ResponseModel<ISearchBarOptionModel>
  > => {
    let response = new ResponseModel<ISearchBarOptionModel>(0, {});
    try {
      const { data, status } = await VetQuestApi().get<ISearchBarOptionModel>(
        "options/searchbar"
      );
      if (data && status === 200) {
        response = new ResponseModel<ISearchBarOptionModel>(status, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<ISearchBarOptionModel>(
        error.response.status,
        {},
        error.response
      );
      return response;
    }
  };

  static GetOwneershipTypeOptions = async (): Promise<
    ResponseModel<IOwnershipTypeModel[]>
  > => {
    let response = new ResponseModel<IOwnershipTypeModel[]>(0, []);
    try {
      const { data, status } = await VetQuestApi().get<IOwnershipTypeModel[]>(
        "options/OwnershipTypes"
      );
      if (data && status === 200) {
        response = new ResponseModel<IOwnershipTypeModel[]>(status, data);
      }
      return response;
    } catch (error) {
      response = new ResponseModel<IOwnershipTypeModel[]>(
        error.response.status,
        [],
        error.response
      );
      return response;
    }
  }
}
